// src/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = "https://api.ebnhaian.cloud";

// نصدر socket ثابت واحد فقط
export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  reconnection: true,
  autoConnect: true, // ✅ يربط تلقائيًا
});
